import React from 'react';
import PropTypes from 'prop-types';
import { Badge, TableCell, TableRow, Typography } from '@mui/material';
import Btn from 'components/button';
import { commonStyles as style } from 'assets/style';

const CustomConfigButton = ({ onClick, disabled, loading, isFilled, label, btnLabel, testId, sxStyle = {} }) => {
    return (
        <TableRow>
            <TableCell align="left" style={{ width: '30%' }}>
                <Typography
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    {label}
                </Typography>
            </TableCell>
            <TableCell align="right" style={{ width: '20%', padding: '6px 5px' }}>
                <Badge color="error" sx={{ ...style.tagBadge, ...sxStyle.badge }} variant={isFilled === false ? 'dot' : 'standard'}>
                    <Btn
                        size="small"
                        disabled={disabled}
                        onClick={onClick}
                        variant="contained"
                        data-testid={testId}
                        className="btn-disabled"
                        sx={{ ...style.primaryMediumButton, ...sxStyle.btn }}
                        loading={loading}
                    >
                        {btnLabel}
                    </Btn>
                </Badge>
            </TableCell>
        </TableRow>
    );
};

CustomConfigButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    isFilled: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    btnLabel: PropTypes.string.isRequired,
    testId: PropTypes.string,
    sxStyle: PropTypes.object,
};

CustomConfigButton.defaultProps = {
    loading: false,
    disabled: false,
    testId: 'custom-config-button',
    sxStyle: {},
};

export default CustomConfigButton;
